// Shared formatting helpers (plan §P1.9 — UI Workflow Consistency Audit).
//
// Several components were carrying their own private copies of these
// helpers (PipelineRunner, CommandCenterPage, DownloadCenter,
// InputUploader). Centralising them here removes ~40 lines of duplicate
// code and gives every surface the same string for the same number.

/**
 * Render a byte count as a human-friendly string ("12 B" / "3.4 KiB" /
 * "1.20 MiB"). Used by every artifact list, upload row, and bundle-size
 * readout.
 */
export function humanBytes(n: number): string {
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KiB`
  return `${(n / 1024 / 1024).toFixed(2)} MiB`
}

/**
 * Build the canonical zero-padded run folder path (``runs/run-007``) so
 * components don't keep re-implementing the ``padStart(3, '0')`` dance.
 */
export function runFolder(runId: number): string {
  return `runs/run-${String(runId).padStart(3, '0')}`
}

/**
 * Convenience wrapper that returns the artifact path inside a run
 * folder, e.g. ``phaseFile(2, 'phase1', 'project-charter.md')`` →
 * ``runs/run-002/phase1/project-charter.md``.
 */
export function phaseFile(runId: number, phaseDir: string, name: string): string {
  return `${runFolder(runId)}/${phaseDir}/${name}`
}
